import * as fabric from "fabric";

export const STAND = 'stand'
export const DEVICE = 'device'
export const BARRIER = 'barrier'
export const TVTEXT = 'HERE'

export const CANVAS_WIDTH = 1200
export const CANVAS_HEIGHT = 730
export const FONT_SIZE = 20;

export interface SelectedObjectI{
    canvasObjectID: string,
    metadata: ObjectData,
}

export interface ObjectData {
    type: string,
    ids: string[] | null,
    attachMouseDownEvent: boolean
}

//@ts-ignore
export function createPolygon(points): fabric.Polygon {
    return new fabric.Polygon(points, {
        fill: '#B5D5FC',
        stroke:'#88BCFA',
        selectable: true,
    });
}

export function createRectangle(canvas: fabric.Canvas, id: string) {
    return new fabric.Rect({
        left: canvas.getWidth() / 2 - 25,
        top: canvas.getHeight() / 2 - 25,
        fill: '#B5D5FC',
        stroke:'#88BCFA',
        width: 50,
        height: 50,
        id: id,
    });
}

export function getModifiedStandObjectWithStandNumber(canvas: fabric.Canvas, objectId: string, standNumber:string) {
    let standObjects: any[] = [];
    const objects = canvas.getObjects();
    for(let i=0; i<objects.length;i++){
        //@ts-ignore
        if(objects[i].id === objectId){
            standObjects.push(objects[i])
            canvas.remove(objects[i]);
        }
    }
    let params = {
        width: 50,
        height: 50,
        left: canvas.getWidth() / 2 - 25,
        top: canvas.getHeight() / 2 - 25,
        textLeft: 0,
        textWidth: 0,
        textTop: 0,
        textHeight: 0,
        scaleX:1,
        scaleY:1,
        points:null,
        angle:0,
        path: null,
        pathOffset: null
    }

    let i = 0;
    if (standObjects.length == 1) {
        params.width = standObjects[i].width1 ?? standObjects[i].width;
        params.height = standObjects[i].height1 ?? standObjects[i].height;
        params.left = standObjects[i].left1 ?? standObjects[i].left;
        params.top = standObjects[i].top1 ?? standObjects[i].top;
        params.textLeft = standObjects[i].left;
        params.textTop = standObjects[i].top;
        params.textWidth = standObjects[i].width;
        params.textHeight = standObjects[i].height;
        params.scaleX = standObjects[i].scaleX;
        params.scaleY = standObjects[i].scaleY;
        if(standObjects[i]._objects){
        params.angle = standObjects[i]._objects[0].angle;
        } else {
            params.angle = 0;
        }
        if(standObjects[i].points){
            params.points=standObjects[i].points;
        }
        if(standObjects[i].path){
            params.path=standObjects[i].path;
        }
        if(standObjects[i].pathOffSet){
            params.pathOffset=standObjects[i].pathOffset;
        }
    } else if (standObjects.length == 2) {
        if (standObjects[i].text) {
            i = 1;
        }
        params.width = standObjects[i].width1 ?? standObjects[i].width;
        params.height = standObjects[i].height1 ?? standObjects[i].height;
        params.left = standObjects[i].left1 ?? standObjects[i].left;
        params.top = standObjects[i].top1 ??  standObjects[i].width;
        params.textLeft = standObjects[i].left;
        params.textTop = standObjects[i].top;
        params.textWidth = standObjects[i].width;
        params.textHeight = standObjects[i].height;
        params.scaleX = standObjects[i].scaleX;
        params.scaleY = standObjects[i].scaleY;
        if(standObjects[i]._objects){
            params.angle = standObjects[i]._objects[0].angle;
        } else {
            params.angle = 0;
        }
        if(standObjects[i].points){
            params.points=standObjects[i].points;
        }
        if(standObjects[i].path){
            params.path=standObjects[i].path;
        }
        if(standObjects[i].pathOffSet){
            params.pathOffset=standObjects[i].pathOffset;
        }
    }


    return createStandWithStandNumber(params,objectId,standNumber);
}

export function createStandWithStandNumber(params: any, objectId: string, standNumber: string) {

    let stand;
    let text;
    if(params.path) {
        stand = new fabric.Path(params.path, {
            fill: '#B5D5FC',
            stroke: '#88BCFA',
            selectable: true,
            objectCaching: false,
        });
        if (params.pathOffset) {
            stand.pathOffset = new fabric.Point(params.pathOffset.x, params.pathOffset.y);
        }
        stand.set('id', objectId)
        const bounds = stand.getBoundingRect();
        text = new fabric.Text(standNumber + '', {
            id: objectId,
            left: bounds.left + bounds.width / 2,
            top: bounds.top + bounds.height / 2,
            fontSize: FONT_SIZE,
            fill: 'black',
            hasBorders: false,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            originX: 'center',
            originY: 'center',
            angle: 0
        });
        stand.set({ originX: 'left', originY: 'top' });
        text.set({ originX: 'left', originY: 'top' });
    } else if (params.points) {
        stand = createPolygon(params.points)
        stand.set('id', objectId)
        stand.set('left', params.left)
        stand.set('top', params.top);
        text = new fabric.Text(standNumber + '', {
            id: objectId,
            width: stand.width,
            height: stand.height,
            left: stand.left + stand.width / 2,
            top: stand.top + stand.height / 2,
            fontSize: FONT_SIZE,
            fill: 'black',
            hasBorders: false,
            scaleX: stand.scaleX,
            scaleY: stand.scaleY,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            originX: 'center',
            originY: 'center',
            angle: 0
        })
    } else {
        stand = new fabric.Rect({
            left: params.left,
            top: params.top,
            fill: '#B5D5FC',
            hasBorders: true,
            stroke: '#88BCFA',
            width: params.width,
            height: params.height,
            angle: params.angle,
            id: objectId,
        });
         text = new fabric.Text(standNumber + '', {
            id: objectId,
            width: params.width,
            height: params.height,
            left: params.textLeft + params.textWidth / 2,
            top: params.textTop + params.textHeight / 2,
            fontSize: FONT_SIZE,
            fill: 'black',
            hasBorders: false,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            originX: 'center',
            originY: 'center',
            angle:0
        })
    }
    let group;
    if(stand instanceof fabric.Path) {
        group = new fabric.Group([stand, text], {
                width: params.width,
                height: params.height,
                scaleX: params.scaleX,
                scaleY: params.scaleY,
                lockRotation: true,
                left: params.left,
                top: params.top,
                originX: 'left',
                originY: 'top'
            });
    } else {
        group = new fabric.Group([stand, text], {
        width: params.width,
        height: params.height,
        scaleX: params.scaleX,
        scaleY: params.scaleY,
        lockRotation: true,
        });
    }
    group.set('id', objectId);
    group.set('width1', params.width);
    group.set('height1', params.height);
    group.set('left1', params.left);
    group.set('top1', params.top);
    group.set('points', params.points ?? null);
    group.set('path', params.path ?? null);
    group.set('pathOffSet', params.pathOffSet ?? null);
    let textIndex = 0;
    //@ts-ignore
    if(!group._objects[textIndex].text){
        textIndex=1;
    }
    //@ts-ignore
    group._objects[textIndex].set('angle',-group.angle)
    return group;
}

export function createTv(left: number, top: number) {

    const tvBody = new fabric.Rect({
        fill: 'black',
        stroke: 'black',
        strokeWidth: 2,
        width: 30,
        height: 15,
        rx: 5,
        ry: 5
    });

    const tvText = new fabric.Text(TVTEXT,{
        width:30,
        height:15,
        left:tvBody.left+16,
        top:tvBody.top+9,
        fontSize: 10,
        fill: 'white',
        fontWeight: 'bold',
        fontFamily: 'Arial',
        originX: 'center',
        originY: 'center'
    })

    return new fabric.Group([tvBody, tvText], {
        width:30,
        height:15,
        left: left,
        top: top,
        lockScalingX: true,
        lockScalingY: true,
        lockRotation: true,
        hasControls: false,
        selectable: true
    });
}

export function createLine(canvas: fabric.Canvas): fabric.Line {
    const canvasCenterX = canvas.getWidth() / 2;
    const canvasCenterY = canvas.getHeight() / 2;
    return new fabric.Line(
        [canvasCenterX - 50, canvasCenterY, canvasCenterX + 50, canvasCenterY],
        {
            stroke: 'gray',
            strokeWidth: 1,
            selectable: true,
        }
    );
}

//@ts-ignore
export function createTemporaryLine(points, i){
    return new fabric.Line(
        //@ts-ignore
        [points[i - 1].x, points[i - 1].y, points[i].x, points[i].y],
        {
            stroke: 'blue',
            strokeWidth: 2,
            selectable: false,
            isTemporary: true, // Mark this line as temporary
        }
    );
}
